import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { Product } from './product.model';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Component, Injector } from '@angular/core';
import { ProductsService } from 'src/app/pages/products/products.service';
import { AuthService } from 'src/app/shared/services/auth.service';
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent extends BaseListComponent<Product>{
  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}

  protected tableProprieties(): string[] {
    const columns= [
      'Código', 
      'Titulo', 
      'Categoria',
      'Subcategoria',
      'Clube/Entidade',
    ]

    
    if(!this.isAdminOrUserKhuzela()) {
      columns.splice(columns.length-1,1)
    }

    return columns;
  }

  products: any[] = []
  loadingSpin: boolean = false

  constructor(
    public productsServ: ProductsService,
    public injector: Injector,
    public auth:AuthService,
    public toastr: ToastrManager,
  ) {
    super(productsServ,injector,'product',{createUrl:'/admin/products/new',editUrl:'/admin/products/edit',detailUrl:'/admin/products/detail'});
   }

}
